import controllerBinder from './../controllers/controller-binder';
import imgSrcController from './../controllers/image-src-controller';
import srcsetController from './../controllers/srcset-controller';
import mapController from './../controllers/map-controller';
import imageRemoveController from './../controllers/image-remove-controller';
import internalController from './../controllers/internal-controller';
import animationController from './../controllers/animation-controller';
import scrollController from './../controllers/scroll-controller';
import gradientController from './gradient-controller';
import viewedController from './viewed-controller';
import viewedElementController from './viewed-element-controller';
import imageErrorController from './image-error-controller';
import autoSwipeController from './auto-swipe-controller';

export type Controllers = {
    [key: string]: { callable: (document: HTMLElement) => void };
};

const controllers: Controllers = {
    imgSrcController,
    srcsetController,
    imageRemoveController,
    internalController,
    animationController,
    scrollController,
    gradientController,
    viewedController,
    viewedElementController,
    imageErrorController,
    mapController,
    autoSwipeController,
};

function main() {
    controllerBinder(document.documentElement, controllers);
}

export default function externalControllers() {
    document.addEventListener('DOMContentLoaded', main);
}
